{
  "currentEnvironment": "${CURRENT_ENVIRONMENT}",
  "sentryDsn": "${SENTRY_DSN}",
  "gtmId": "${GTM_ID}",
  "regionalResourceCode": "${REGIONAL_RESOURCE_CODE}",
  "formTemplatesDisabled": "${FORM_TEMPLATES_DISABLED}",
  "referralsDisabled": "${REFERRALS_DISABLED}",
  "allowedCountriesPhoneList": "${ALLOWED_COUNTRIES_PHONE_LIST}",
  "preferredCountriesPhoneList": "${PREFERRED_COUNTRIES_PHONE_LIST}",
  "campaignTrackingDisabled": "${CAMPAIGN_TRACKING_DISABLED}",
  "maintenanceModeActive": "${MAINTENANCE_MODE_ACTIVE}",
  "maintenanceAvailableAppPath": "${MAINTENANCE_AVAILABLE_APP_PATH}"
}
